import BaseRepository from 'Domain/Repositories/BaseRepository/BaseRepository';
import { Option }   from 'Domain/Models';

const config = {
    model: Option,
    baseRoute: '/admin/settings',
    singular: 'event',
    plural: 'events',
}

class SettingsRepository extends BaseRepository<Option, typeof config.singular, typeof config.plural> {

  findAllOptions() {
    return this.makeRequest({
      path: `/admin/settings`,
      type: 'GET',
      callback: this.initializeSettings,
    });
  }

  updateOptions(updateData = {}) {
    return this.makeRequest({
      path: `/admin/settings`,
      type: 'PATCH',
      data: updateData,
      callback: this.initializeSettings,
    });
  }

  reloadSettings() {
    return this.makeRequest({
      path: `/admin/settings/reload`,
      type: 'GET',
      callback: this.initializeSettings,
    });
  }

  initializeSettings = (responseObject: { options: Record<string, unknown>}): { options: Record<string, unknown>} => {
    return { options: responseObject.options };
  };

}

export default new SettingsRepository(config);
